import React, { useEffect } from "react";
import { HttpStatusCode } from "axios";
import { useNavigate } from "react-router-dom";

import {
  UserPushInfo,
  getUserPush,
  updateUserPush,
} from "../../../../services/pushServices";

import useSimplePopup from "../../../../hooks/useSimplePopup";
import useFullScreenLoading from "../../../../hooks/useFullScreenLoading";

import { MyInfoConfigRow } from "..";
import StickyHeader from "../../../../components/Layout/StickyHeader";
import CommonSwitch from "../../../../components/Input/Switch";

type Props = {};

export default function MyInfoConfigPushUser(props: Props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [push, setPush] = React.useState<UserPushInfo>();
  const [simplePopupComponent, { open }] = useSimplePopup({});

  const loadUserPush = async () => {
    setIsLoading(true);
    try {
      const res = await getUserPush();
      if (res.status === HttpStatusCode.Ok && res.data !== "") {
        setPush(res.data);
      } else {
        if (res?.data === "") {
          open("알림 설정으로 빈 데이터를 내려받았습니다.");
        } else {
          open("알림 설정을 불러오는데 실패했습니다.");
        }
      }
    } catch (e: any) {
      if (e?.response?.data?.error) {
        open(e.response.data.error?.replace(". ", ".\n"));
      } else {
        open("알림 설정을 불러오는데 실패했습니다.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = async (params: Partial<UserPushInfo>) => {
    setIsLoading(true);
    try {
      await updateUserPush({ ...push, ...params });
    } catch (e: any) {
      console.log(e);
    } finally {
      loadUserPush();
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadUserPush();
  }, []);

  return (
    <div>
      {loadingComponent}
      <StickyHeader
        title="서비스 이용알림 수신 설정"
        onBackClick={() => navigate("/myinfo/config")}
        className="px-5"
      />

      <MyInfoConfigRow>
        <div>불편신고 알림</div>
        <CommonSwitch
          variant="black"
          value={push?.incommodity}
          onClick={() => handleClick({ incommodity: !push?.incommodity })}
        />
      </MyInfoConfigRow>

      <MyInfoConfigRow>
        <div>신청서비스 알림</div>
        <CommonSwitch
          variant="black"
          value={push?.service}
          onClick={() => handleClick({ service: !push?.service })}
        />
      </MyInfoConfigRow>

      <MyInfoConfigRow>
        <div>대여하기 알림</div>
        <CommonSwitch
          variant="black"
          value={push?.rent}
          onClick={() => handleClick({ rent: !push?.rent })}
        />
      </MyInfoConfigRow>

      <MyInfoConfigRow>
        <div>공간예약 알림</div>
        <CommonSwitch
          variant="black"
          value={push?.reservation}
          onClick={() => handleClick({ reservation: !push?.reservation })}
        />
      </MyInfoConfigRow>

      <MyInfoConfigRow>
        <div>샌디톡 알림</div>
        <CommonSwitch
          variant="black"
          value={push?.talkReply}
          onClick={() => handleClick({ talkReply: !push?.talkReply })}
        />
      </MyInfoConfigRow>
      {simplePopupComponent}
    </div>
  );
}
